(() => {
  if (window.iStoreCareersSliderLoaded) return;
  window.iStoreCareersSliderLoaded = true;

  const setup = (slider) => {
    if (slider.dataset.careersSliderReady === "true") return;

    const viewport = slider.querySelector("[data-careers-viewport]");
    const track = slider.querySelector("[data-careers-track]");
    const previous = slider.querySelector("[data-careers-previous]");
    const next = slider.querySelector("[data-careers-next]");
    if (!viewport || !track) return;

    slider.dataset.careersSliderReady = "true";

    const update = () => {
      const maximum = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      const canScroll =
        maximum > 1 &&
        window.getComputedStyle(viewport).overflowX !== "visible";
      if (previous) {
        previous.hidden = !canScroll;
        previous.disabled = !canScroll || viewport.scrollLeft <= 1;
      }
      if (next) {
        next.hidden = !canScroll;
        next.disabled = !canScroll || viewport.scrollLeft >= maximum - 1;
      }
      const controls = slider.querySelector(".istore-careers-people__controls");
      if (controls) controls.hidden = !canScroll;
    };

    const move = (direction) => {
      const item = track.querySelector("[data-careers-item]");
      if (!item) return;
      const gap =
        Number.parseFloat(window.getComputedStyle(track).columnGap) || 0;
      const distance = item.getBoundingClientRect().width + gap;
      const behavior = window.matchMedia("(prefers-reduced-motion: reduce)")
        .matches
        ? "auto"
        : "smooth";
      viewport.scrollBy({ left: direction * distance, behavior });
    };

    previous?.addEventListener("click", () => move(-1));
    next?.addEventListener("click", () => move(1));
    viewport.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update, { passive: true });
    if ("ResizeObserver" in window)
      new ResizeObserver(update).observe(viewport);
    update();
  };

  const setupAll = (scope = document) => {
    if (scope.matches?.("[data-careers-slider]")) setup(scope);
    scope.querySelectorAll("[data-careers-slider]").forEach(setup);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => setupAll(), {
      once: true,
    });
  } else {
    setupAll();
  }

  document.addEventListener("shopify:section:load", (event) =>
    setupAll(event.target),
  );
})();
